import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { UserDisplay } from "@components/common/user-display";
import { RemoveMemberSuccessDescription } from "@components/remove-member-success-description";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { Alert, Dialog, Text, useToast } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { SnapshotMember } from "@pages/project-details/project-snapshots/snapshot-member";
import { fetchingProjectsFlagsSelector } from "@store/projects/projects-selector";
import { removeMemberFromSnapshot } from "@store/projects/projects-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { SnapshotEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
/** Renders the members of a snapshot */
export function SnapshotMemberList(t0) {
  const $ = _c(31);
  const {
    members,
    snapshot,
    location
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const {
    openToast
  } = useToast();
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    isRemovingSnapshotMember
  } = useAppSelector(fetchingProjectsFlagsSelector);
  const [memberToRemove, setMemberToRemove] = useState(null);
  let t1;
  if ($[0] !== companyId || $[1] !== dispatch || $[2] !== handleErrorWithToast || $[3] !== location || $[4] !== memberToRemove || $[5] !== openToast || $[6] !== snapshot || $[7] !== trackEvent) {
    t1 = async function removeMember() {
      if (!memberToRemove) {
        return;
      }
      trackEvent({
        name: SnapshotEvents.removeMember,
        props: {
          eventLocation: location
        }
      });
      ;
      try {
        await dispatch(removeMemberFromSnapshot({
          companyId,
          member: memberToRemove,
          snapshotId: snapshot.id
        })).unwrap();
        setMemberToRemove(null);
        openToast({
          title: "Member removed from snapshot",
          message: <RemoveMemberSuccessDescription member={memberToRemove} subjectType="snapshot" entityName={snapshot.name} />
        });
      } catch (t2) {
        const error = t2;
        handleErrorWithToast({
          id: `removeMemberFromSnapshot-${Date.now().toString()}`,
          title: "Could not remove member from snapshot",
          error
        });
      }
    };
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = handleErrorWithToast;
    $[3] = location;
    $[4] = memberToRemove;
    $[5] = openToast;
    $[6] = snapshot;
    $[7] = trackEvent;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const removeMember = t1;
  if (members.length === 0) {
    let t2;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Alert variant="info" title="This snapshot has no invited members" />;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function onSelectOption(t3, member) {
      const {
        target
      } = t3;
      if (target.value === "remove") {
        setMemberToRemove(member);
      }
    };
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const onSelectOption = t2;
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      maxHeight: "300px",
      overflow: "auto",
      gap: 2
    };
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== members || $[13] !== snapshot) {
    let t5;
    if ($[15] !== snapshot) {
      t5 = member_0 => <SnapshotMember key={member_0.identity} snapshot={snapshot} member={member_0} onSelectOption={onSelectOption} />;
      $[15] = snapshot;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t4 = members.map(t5);
    $[12] = members;
    $[13] = snapshot;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[17] !== t4) {
    t5 = <Stack sx={t3}>{t4}</Stack>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const t6 = memberToRemove !== null;
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setMemberToRemove(null);
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text variant="bodyM" sx={{
      marginBottom: SPACE_ELEMENTS_OF_MODAL
    }}>When removing member from snapshot they may no longer be able to access this snapshot. You can always invite this member again.</Text>;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== memberToRemove) {
    t9 = memberToRemove && <UserDisplay member={memberToRemove} />;
    $[21] = memberToRemove;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== isRemovingSnapshotMember || $[24] !== removeMember || $[25] !== t6 || $[26] !== t9) {
    t10 = <Dialog title="Remove from snapshot" confirmText="Remove" open={t6} onConfirm={removeMember} onCancel={t7} showSpinner={isRemovingSnapshotMember}>{t8}{t9}</Dialog>;
    $[23] = isRemovingSnapshotMember;
    $[24] = removeMember;
    $[25] = t6;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t5) {
    t11 = <>{t5}{t10}</>;
    $[28] = t10;
    $[29] = t5;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
}